export enum ActionButtonType {
  RouterLink,
  Command,
  Url,
}
